import Vue from 'vue';
import Router from 'vue-router';
import Layout from './views/Layout.vue';

import { jwtService } from './services/jwt.service';

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/employees',
      component: Layout,
      children: [
        {
          path: '/employees',
          name: 'EmployeesView',
          component: load('Home'),
        },
        {
          path: '/rides',
          name: 'RidesView',
          component: load('Rides')
        },
        {
          path: '/faq',
          name: 'Faq',
          component: load('Faq')
        },
      ],
    },
    {
      path: '/login',
      name: 'LoginView',
      component: load('Login')
    },
    {
      path: '/forgot-password',
      name: 'ForgotPasswordView',
      component: load('ForgotPassword')
    },
    {
      path: '/reset-password',
      name: 'ResetPasswordView',
      component: load('ResetPassword')
    },
  ],
});


/*
 *
 *  Authentication router guard
 *
 */


router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/forgot-password', '/reset-password'];
  const authRequired = !publicPages.includes(to.path);
  const token = localStorage.getItem('token');

  // check jwt not expired
  const jwtNotExpired = jwtService.isTokenExpired(token || '');

  /*
   *
   *  Turned off (due to removed exp field from jwt)
   *
   */


  if (authRequired && jwtNotExpired) {
    return next('/login');
  }
/*
  if (authRequired && !token) {
    return next('/login');
  }
*/
  next();
});




/*
 *
 * Route level code-splitting
 * this generates a separate chunk ({component}.[hash].js) for this route
 * which is lazy-loaded when the route is visited.
 *
 */

function load(component: string) {
  return () => import(/* webpackChunkName: "[request]" */ `@/views/${component}.vue`);
}

